<div class="wk-pagination__pager">
    <ul [class]="small() ? 'pagination pagination-sm wk-pagination__pager--margin-bottom' : 'pagination wk-pagination__pager--margin-bottom'">
        @if (firstLastButtons()) {
            <li [class]="currentPage() === 1 ? 'page-item disabled' : 'page-item'">
                <button class="wk-pagination__pagerlinknavigation" (click)="selectPageNumber(1)">|&lt;</button>
            </li>
        }
        @if (nextPreviousButtons()) {
            <li [class]="currentPage() === 1 ? 'page-item disabled' : 'page-item'">
                <button class="wk-pagination__pagerlinknavigation" (click)="previous()">&lt;</button>
            </li>
        }
        @if (currentPage() - 1 > 1 && totalPages().length > 4) {
            <li class="page-item disabled">
                <button class="wk-pagination__pagerlinknavigation">...</button>
            </li>
        }

        <!-- page numbers -->
        @for (p of totalDisplayPages(); track p; let i = $index) {
            <li [class]="currentPage() === p ? 'page-item active' : 'page-item'">
                <button class="wk-pagination__pagerlink" (click)="selectPageNumber(p)">{{ p }}</button>
            </li>
        }
        @if (currentPage() + 2 < totalPages().length && totalPages().length > 4) {
            <li class="page-item disabled">
                <button class="wk-pagination__pagerlinknavigation">...</button>
            </li>
        }

        <!-- next button -->
        @if (nextPreviousButtons()) {
            <li [class]="currentPage() === totalPages().length ? 'page-item disabled' : 'page-item'">
                <button class="wk-pagination__pagerlinknavigation" (click)="next()">&gt;</button>
            </li>
        }
        <!-- last button -->
        @if (firstLastButtons()) {
            <li [class]="currentPage() === totalPages().length ? 'page-item disabled' : 'page-item'">
                <button class="wk-pagination__pagerlinknavigation" (click)="selectPageNumber(totalPages.length)">&gt;|</button>
            </li>
        }
    </ul>
</div>
